const TOKEN_KEY = 'auth_token';
const USER_KEY = 'auth_user';

let handlingUnauthorized = false;

function decodeJwtPayload(token) {
  try {
    const segment = token.split('.')[1];
    if (!segment) return null;
    const json = atob(segment.replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(json);
  } catch (_) {
    return null;
  }
}

export function getStoredToken() {
  try {
    return localStorage.getItem(TOKEN_KEY) || '';
  } catch (_) {
    return '';
  }
}

export function isTokenExpired(token, skewSeconds = 30) {
  if (!token) return true;
  const payload = decodeJwtPayload(token);
  if (!payload?.exp) return false;
  return Date.now() >= payload.exp * 1000 - skewSeconds * 1000;
}

export function clearAuthSession() {
  try {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
  } catch (_) {}
}

export function handleUnauthorized() {
  if (handlingUnauthorized) return;
  handlingUnauthorized = true;

  clearAuthSession();
  window.dispatchEvent(new CustomEvent('auth:session-expired'));

  const path = window.location.pathname;
  if (path !== '/login' && path !== '/') {
    window.location.replace('/login?session=expired');
    return;
  }

  handlingUnauthorized = false;
}

export function ensureActiveSession() {
  const token = getStoredToken();
  if (!token || isTokenExpired(token)) {
    handleUnauthorized();
    return false;
  }
  return true;
}

export function setupSessionExpiryListeners() {
  const onVisible = () => {
    if (!document.hidden) {
      ensureActiveSession();
    }
  };

  document.addEventListener('visibilitychange', onVisible);
  window.addEventListener('focus', onVisible);

  return () => {
    document.removeEventListener('visibilitychange', onVisible);
    window.removeEventListener('focus', onVisible);
  };
}
